export type MagicLinkOrganisationCandidate = {
  id: string;
  is_test_clone?: boolean | null;
};

/**
 * A magic link is bound to the organisation selected when it was created.
 * Test clones share the source organisation's contact email and are newer, so
 * "newest org with this email" would open the clone. The session's
 * organisation id always wins, including when that organisation is itself a
 * clone. Email fallbacks skip clones unless every match is a clone and the
 * caller explicitly allows that.
 */
export function pickOrganisationForMagicLink<T extends MagicLinkOrganisationCandidate>(
  organisations: T[],
  options?: { sessionOrganisationId?: string | null; allowTestClone?: boolean },
): T | null {
  const sessionOrganisationId = options?.sessionOrganisationId;
  if (sessionOrganisationId) {
    return organisations.find((org) => org.id === sessionOrganisationId) ?? null;
  }

  const nonClones = organisations.filter((org) => org.is_test_clone !== true);
  if (nonClones.length > 0) return nonClones[0];
  if (options?.allowTestClone) return organisations[0] ?? null;
  return null;
}
